import { render, staticRenderFns } from "./PlanExpiredModal.vue?vue&type=template&id=5aff50fc&"
import script from "./PlanExpiredModal.vue?vue&type=script&lang=ts&"
export * from "./PlanExpiredModal.vue?vue&type=script&lang=ts&"
import style0 from "./PlanExpiredModal.vue?vue&type=style&index=0&id=5aff50fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports